// 9fbef606107a605d69c0edbcd8029e5d 
import React from 'react';
import PropTypes from 'prop-types';
import MyPref from '../organism/MyPreferencesSection.view';

const MyPrefrence = ({ labels, ...otherProps }) => {
  return <MyPref labels={labels} {...otherProps} />;
};

MyPrefrence.propTypes = {
  labels: PropTypes.shape({}),
};

MyPrefrence.defaultProps = {
  labels: {},
};

export default MyPrefrence;
